export const removeTimeMetadataKey = 'removeTimeProperty';

export const ignoreMetadataKey = 'ignoreProperty';
